import uniqueId from '@form-create/utils/lib/unique';
import { makeOptionsRule } from '../../utils/index';
import { makeRequiredRule } from '../../utils';
var label = '多选';
var name = 'checkbox';
export default {
  icon: 'iconfont iconduoxuan1',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      effect: {
        fetch: ''
      },
      props: {},
      options: [{
        value: '选项1',
        label: '选项1'
      }, {
        value: '选项2',
        label: '选项2'
      }]
    };
  },
  props: function props() {
    return [makeOptionsRule('options'), makeRequiredRule()];
  },
  basic: function basic() {}
};